import { z } from 'zod';

export const hearAboutGetResponseSchema = z.object({
  data: z.object({ events: z.array(z.string()).optional(), hear_about: z.array(z.string()).optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
